import React from 'react';
import PropTypes from 'prop-types';

import styled from 'styled-components';

import { breakpoint } from '@constants/styles';
import Text from '@components/Text';
import { dataTestIdFormatter } from '@helpers/utils';

const Row = styled.div`
  padding-top: 29px;
  padding-right: 0;
  padding-bottom: ${({ lastRow }) => (lastRow ? '0px' : `27px`)};
  padding-left: 0;
  display: flex;
  flex-direction: column;
  ${({ theme }) => theme.breakpoint('md')} {
    flex-direction: row;
    padding-top: 30px;
    padding-bottom: ${({ lastRow }) => (lastRow ? '0px' : `30px`)};
  }
  border-bottom: ${({ lastRow, theme }) => (lastRow ? '0px' : `solid 1px ${theme.colors.gray400}`)};
`;
Row.displayName = 'Row';

const RowTitle = styled(Text)`
  margin-bottom: 8px;
  ${breakpoint('medium')`
    min-width: 200px;
    margin-right: 10px;
  `}
`;

const ListInfoCardRow = ({ name, value, lastRow }) => (
  <Row data-testid={`comercio-${dataTestIdFormatter(name)}`} lastRow={lastRow}>
    <RowTitle
      data-testid={`comercio-${dataTestIdFormatter(name)}-title`}
      type="Body-2-w400"
      color="gray700"
    >
      {name}
    </RowTitle>
    <Text
      data-testid={`comercio-${dataTestIdFormatter(name)}-text`}
      smallType="Subtitle-1-w400"
      type="Body-2-w400"
      color="gray800"
    >
      {value || '-'}
    </Text>
  </Row>
);

ListInfoCardRow.propTypes = {
  name: PropTypes.string.isRequired,
  value: PropTypes.any,
  lastRow: PropTypes.bool,
};

ListInfoCardRow.defaultProps = {
  value: null,
  lastRow: false,
};

export default ListInfoCardRow;
